import styled from "styled-components";

export const StyledImg = styled.img`
  ${props => props.noGreyFilter ? "" : "filter: grayscale(100%);"}
`;